export function getPresaleLoading(state) {
    return state.PresaleReducer.isLoading;
}

export function getPresales(state) {
    return state.PresaleReducer.presales;
}